import {combineReducers} from 'redux'
import reportReceipts from'./reportReceipts'
import lossAssDashboard from './lossAssDashboard'
import selectedReport from './selectedReport'
import accidentCars from './accidentCars'
import reportPreview from './reportPreview'
import wxSmallProgramRequest from './wxSmallProgramRequest'
import ocr from './ocr'

const lossAssessmentReducer = combineReducers({
    reportReceipts,
    lossAssDashboard,
    selectedReport,
    accidentCars,
    reportPreview,
    wxSmallProgramRequest,
    ocr
})

export default lossAssessmentReducer
